import {ProductWidget} from '@/lib/TypesOpenApi';
import {ServiceBox} from './ProductBox';
import {proxy} from 'valtio';
import {getAnalytics} from '@/hooks/useAnalytics';

export type StreamingBox = ServiceBox<ProductWidget>;

export interface StreamingServicesBox {
  /** Enabled streaming services */
  services: Array<StreamingBox>;
  products: Array<ProductWidget>;
  serviceIds: Array<string>;
  isServiceAdded: (id: string) => boolean;
}

// if add any new field, add the new field to the below reset function also
export const streaming = proxy<StreamingServicesBox>({
  services: [],

  get products() {
    return this.services.map(({_product: product}: StreamingBox) => product);
  },

  get serviceIds() {
    return this.services.map(({productId}: StreamingBox) => productId!);
  },

  isServiceAdded(id) {
    return this.serviceIds.includes(id);
  },
});

export const resetStreaming = () => {
  streaming.services = [];
};

export const toggleStreamingService = (
  product: ProductWidget,
  price: number,
) => {
  const analytics = getAnalytics();

  const index = streaming.serviceIds.indexOf(product.productId!);

  if (product.productId) {
    analytics.trackStreamingServiceProductSelection(
      product.productId,
      index === -1,
    );
  }

  if (index === -1) {
    streaming.services.push({
      _product: product,
      productId: product.productId,
      // productName currently empty, will fallback to productId to display at least something
      // will be fixed after https://gfiber.atlassian.net/browse/GFENG-17397 completed
      name: product.productName || product.productId!,
      price,
    });
    return;
  }

  streaming.services.splice(index, 1);
};

export const updateStreamingService = (product: ProductWidget) => {
  const price = product.productCost?.units ?? 0;

  const index = streaming.serviceIds.indexOf(product.productId!);
  if (index === -1) {
    console.warn('Cannot updated streaming service, will add', product);
    toggleStreamingService(product, price);
    return;
  }

  streaming.services[index] = {
    _product: product,
    productId: product.productId,
    // productName currently empty, will fallback to productId to display at least something
    // will be fixed after https://gfiber.atlassian.net/browse/GFENG-17397 completed
    name: product.productName || product.productId!,
    price,
  };
};
